export default __webpack_public_path__ + "static/media/cover.a4414a39.jpg";